import { handleError } from 'utilities/utilities';
import { getApiHost } from '../host-by-env';
import { MarketplaceProduct, MarketplaceProductStatus } from './types';

export async function getMarketPlaceProducts(firmId: string | undefined, token: string): Promise<MarketplaceProduct[]> {
  const url = `${getApiHost()}marketplace/products/${firmId}`;
  const response = await fetch(url, {
    method: 'GET',
    headers: { Authorization: `Bearer ${token}` },
  });
  const json = await response.json();
  handleError(json);
  return json.result;
}

export async function toggleMarketPlaceProducts(
  productStatus: MarketplaceProductStatus,
  token: string,
): Promise<MarketplaceProductStatus> {
  const url = `${getApiHost()}marketplace/product/status`;
  const response = await fetch(url, {
    method: 'PUT',
    body: JSON.stringify({
      ...productStatus,
    }),
    headers: { Authorization: `Bearer ${token}` },
  });
  const json = await response.json();
  handleError(json);
  return json.result;
}
